// extracted by mini-css-extract-plugin
export default {"map-wrapper":"client-components-common-map-___map__map-wrapper___1tJ7v","map-loader":"client-components-common-map-___map__map-loader___3vtYx"};